import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white pt-20 pb-10 border-t-4 border-brand-orange">
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        {/* Column 1: About */}
        <div className="space-y-6">
          <div className="flex items-center gap-3">
            <img 
              src="https://assets.auxodev.dk/assets/c68264d9-2499-44ef-9e49-6b5cd7a6c3b2/1008-t-c3-b8mrer.svg" 
              alt="BAW Byg og Konstruktion Logo" 
              className="h-16 md:h-20 w-auto object-contain brightness-0 invert"
            />
          </div>
          <p className="text-slate-300 text-sm leading-relaxed">
            BAW Byg og Konstruktion drives af Benjamin Petersen, uddannet tømrer og byggetekniker. Vi har stort fokus på at levere førsteklasses håndværk.
          </p>
          <p className="text-slate-300 text-sm leading-relaxed">
            Vi går professionelt to opgaven uanset størrelsen, og tilbyder erfaren rådgivning om kundens muligheder.
          </p>
        </div>

        {/* Column 2: Services */}
        <div>
          <h4 className="font-display font-bold text-sm text-brand-orange mb-6 uppercase tracking-widest">
            Ydelser
          </h4>
          <ul className="space-y-3 text-xs uppercase tracking-wider font-bold">
            <li>
              <Link to="/ydelser/totalentreprise" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Totalentreprise
              </Link>
            </li>
            <li>
              <Link to="/ydelser/toemreropgaver" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Generelle tømreropgaver
              </Link>
            </li>
            <li>
              <Link to="/ydelser/renovering-af-hus" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Renovering af bolig
              </Link>
            </li>
            <li>
              <Link to="/ydelser/opbygning-af-traeterrasse" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Ny træterrasse
              </Link>
            </li>
            <li>
              <Link to="/projekter" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Projekter og referencer
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Quick Links */}
        <div>
          <h4 className="font-display font-bold text-sm text-brand-orange mb-6 uppercase tracking-widest">
            Hurtige links
          </h4>
          <ul className="space-y-3 text-xs uppercase tracking-wider font-bold">
            <li>
              <Link to="/" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Gå til forsiden
              </Link>
            </li>
            <li>
              <Link to="/om-os" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Om os
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Modtag et byggetilbud
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="text-slate-300 hover:text-brand-orange transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-orange"></i>
                Kontakt os i dag
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Contact info */}
        <div>
          <h4 className="font-display font-bold text-sm text-brand-orange mb-6 uppercase tracking-widest">
            Firmaoplysninger
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-building text-brand-orange mt-1 shrink-0"></i>
              <div>
                <span className="font-bold block text-white">BAW Byg og Konstruktion</span>
                <span className="text-slate-400 text-xs">v/ Benjamin A. W. Petersen</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-location-dot text-brand-orange mt-1 shrink-0"></i>
              <a
                href="https://www.google.com/maps/place/%C3%98ster+Kringelvej+7,+8250+Eg%C3%A5/@56.214598,10.2633334,1304m/data=!3m2!1e3!4b1!4m6!3m5!1s0x464c3e85843f2b79:0x599fb2843f76de85!8m2!3d56.214595!4d10.2659083!16s%2Fg%2F11c1bdf9qq?entry=ttu"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-brand-orange transition-colors leading-relaxed"
              >
                Øster Kringelvej 7<br />8250 Egå
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-brand-orange shrink-0"></i>
              <a href="tel:+4529678107" className="text-slate-300 hover:text-brand-orange transition-colors whitespace-nowrap font-bold">
                +45 2967 8107
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-brand-orange shrink-0"></i>
              <a href="mailto:kontakt@baw-byg.dk" className="text-slate-300 hover:text-brand-orange transition-colors whitespace-nowrap font-bold">
                kontakt@baw-byg.dk
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-id-card text-brand-orange shrink-0"></i>
              <span className="text-slate-300">CVR: 28620136</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mx-auto max-w-7xl px-6 md:px-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400 text-center sm:text-left">
        <div>
          © {new Date().getFullYear()} BAW Byg og Konstruktion. Alle rettigheder forbeholdes.
        </div>
        <div className="flex items-center gap-6">
          <a href="https://www.iubenda.com/privacy-policy/29210425" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors" title="Privatlivspolitik ">Privatlivspolitik</a>
          <a href="https://www.iubenda.com/privacy-policy/29210425/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors" title="Cookiepolitik ">Cookiepolitik</a>
        </div>
      </div>
    </footer>
  )
}
